import Table from 'src/javascripts/components/Table';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import BuildApiUrl from 'src/javascripts/components/tables/url/BuildApiUrl';
import AddRowHoverButtons from 'src/javascripts/components/tables/helpers/AddRowHoverButtons';
import AddRowClickLinks from 'src/javascripts/components/tables/actions/AddRowClickLinks';
import GetCols from 'src/javascripts/components/tables/helpers/GetCols';
import CheckPaging from 'src/javascripts/components/tables/helpers/CheckPaging';
import Swal from 'sweetalert2';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

export default class QuestionnaireMetricsTable extends Table {

  render() {

    // Set a spinner to indicate chart loading
    Spinner(this.el.closest('.card'));
    this.el.closest('.card-body').css('opacity', 0);

    // Set table id
    const tableId = this.el.attr('id');

    // Build url, use to get filtered data with server-side processing
    let dataUrl = this.el.attr('data-api-url');
    let metricTableId = this.el.attr('data-metric-table-id');
    let detailColumns = this.el.attr('data-detail-columns');
    let portfolioId = this.el.attr('data-portfolio-id');
    let year = this.el.attr('data-year');
    let excluded = this.el.attr('data-excluded');
    let dataTypes = this.el.attr('data-data-types');
    let params = {};
    if (typeof metricTableId !== 'undefined') {params['metric_table_id'] = metricTableId;}
    if (typeof detailColumns !== 'undefined') {params['detail_columns'] = detailColumns;}
    if (typeof portfolioId !== 'undefined') {params['portfolio_id'] = portfolioId;}
    if (typeof year !== 'undefined') {params['year'] = year;}
    if (typeof excluded !== 'undefined') {params['excluded'] = excluded;}
    if (typeof dataTypes !== 'undefined') {params['data_types'] = dataTypes;}
    dataUrl = dataUrl + '?' + $.param(params);

    // Render table
    // Responsive - details: false - don't show hidden details on small devices 
    // (https://datatables.net/reference/option/responsive)
    const table = $('#' + tableId).DataTable({
      ajax: dataUrl,
      orderCellsTop: true,
      responsive: true,
      retrieve: true,
      serverSide: false,
      // scrollY: scrollYHeight,
      scrollX: true,
      // autoWidth: true,
      scrollCollapse: true,
      fixedColumns: {leftColumns: 2},
      paging: false,
      ordering: true,
      order: [[1, 'asc']],
      searching: true,
      dom: 'tlp',
      language: { 
        lengthMenu: "Show _MENU_ responses",
        infoEmpty: "No response data found. Reach out to us with any questions.",
        emptyTable: "No response data found. Reach out to us with any questions.",
        zeroRecords: "No response data found. Reach out to us with any questions."
      },

      initComplete: function( settings ) {

        // Remove spinner after table has drawn
        $('#' + tableId).closest('.card').find('.spinner-container').remove();
        $('#' + tableId).closest('.card-body').css('opacity', 1);

        // Adjust height
        let headerHeight = $('#' + tableId).closest('.card-body').find('.dataTables_scrollHead').height();
        let cardBodyHeight = $('#' + tableId).closest('.card-body').height();
        let newH = cardBodyHeight - headerHeight - 60;
        if ($('.card.full-view').length !== 0) {newH = newH - 50}
        $('.dataTables_scrollBody').css('min-height', newH + 'px').css('max-height', newH + 'px');

        // Make second footer row sticky
        $('tfoot tr td:first-child').css('position', 'sticky').css('left', 0);

        // Add symbols to rows
        let symbols = settings.json.symbols
        $.each(symbols, function(index, sym) {
          $('#' + tableId).find('tbody tr').eq(index).attr('data-record-symbol', sym);
        })

        // Create total rows
        let aggregate = settings.json.aggregate
        $.each(aggregate, function(index, arr) {
          $('.dataTables_scrollFoot td.aggregate[data-key=\'' + arr[0] + '\']').empty().append(arr[1]);
        })
        let percents = settings.json.percents
        $.each(percents, function(index, arr) {
          $('.dataTables_scrollFoot td.percents[data-key=\'' + arr[0] + '\']').empty().append(arr[1]);
        })

      }


    });

    return 'rendered';
  }

  setUp(tableId) {

    // Set table
    let oTable = $('#' + tableId).DataTable();

    // Set searchable function for table
    $('#search_' + tableId).keyup(function(){
      oTable.search( $(this).val() ).draw();
    });

    // Ensure search input starts blank
    $('#search_' + tableId).val('');

    // On resize
    $(window).resize(function() {

      // Adjust height
      let headerHeight = $('#' + tableId).closest('.card-body').find('.dataTables_scrollHead').height();
      let cardBodyHeight = $('#' + tableId).closest('.card-body').height();
      let newH = cardBodyHeight - headerHeight - 60;
      if ($('.card.full-view').length !== 0) {newH = newH - 50}
      $('.dataTables_scrollBody').css('min-height', newH + 'px').css('max-height', newH + 'px');

    })


    return 'setup';

  }


}
